import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Game } from '../models/game';
import { map } from 'rxjs/operators';
import { VolleyballGameTeamStatistic } from '../models/volleyball-game-team-statistic';
import { VolleyballGameStatistic } from '../models/volleyball-game-statistic';
import { VolleyballGameLog } from '../models/volleyball-game-log';
import { ConfigService } from '../services/config.service';
import { GameBaseApi } from './game-base-api';

@Injectable({providedIn: 'root'})
export class VolleyballGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<VolleyballGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/team_statistic/`).pipe(
      map(result => VolleyballGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<VolleyballGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/user_statistic/`).pipe(
      map(result => VolleyballGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<VolleyballGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/logs/`).pipe(
      map(result => VolleyballGameLog.toFront(result))
    ).toPromise();
  }

  async downloadProtocolLight(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol_light/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadProtocolAdvanced(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol_advanced/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadProtocol(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }
}
